/** Auto-dismiss duration for regular HP step toasts without an UNDO action (5 seconds) */
export const HP_TOAST_DURATION = 5000;

/** Auto-dismiss duration for actionable HP step toasts with an UNDO action (7 seconds) */
export const HP_TOAST_UNDO_DURATION = 7000;

/** Static toast messages for HP step operations. */
export enum StepToastMessage {
  AllStepsReverted = 'All unsaved changes are reset to their original state.',
  ClinicalReorderFailed = 'Failed to save step order.',
  ClinicalSaveFailed = 'Failed to save step. Please try again.',
  ClinicalStepCreated = 'New step added. Step bar updated.',
  ClinicalStepCreatedWithRevert = 'New step created. Original step reset to original state.',
  ClinicalStepReverted = 'Changes discarded. Step reset to original state.',
  ClinicalStepSaved = 'Step updated with your changes.',
  CreateFailed = 'Failed to create step. Please try again.',
  DeleteFailed = 'Failed to delete step. Please try again.',
  FormStepCreated = 'New step created.',
  StepDeleted = 'Step deleted.',
}
